import axios from 'axios'

axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common.Authorization = localStorage.getItem('token')
axios.defaults.headers.common.Api = '248c13b07ddccfb337ed1fb236c8a8e8d78d160a7d9e067e4ddf974f80308edce345279fa0782fd5062dc1786547b6b21c29f70e21f064c35bd01e1b0de2ff90'

export default axios
